<template lang="html">
  <div class="loaderParent">
    <div class="loader d-block">
        <div class="row justify-content-end p-1"><i class="col-3 text-center cursor-pointer" style="color: white; font-size: 1.5rem;" @click="crossClose">&#10005;</i></div>
      <div :style="width" class="mx-auto h-100 popupwidth overflowAuto" style="overflow: auto">
          <img :src="getBaseData(imageLink)" style="width: inherit"/>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */


export default {
    name: "ImageViewer",
  props: {
    imageLink: {
      type: String
    }
  },
  components: {
  },
  data() {
    return {
    };
  },
  watch: {
  },
  mounted() {
  },
  computed: {
      width() {
        return "width: 90%";
    },
  },
  methods: {
    getBaseData (url) {
      return `data:image/png;base64, ${url}`
    },
    crossClose() {
      this.$emit("closePopup");
    }
  }
};
</script>
<style scoped>
.popupwidth::-webkit-scrollbar {
  display: none;
}

@media screen and (max-width: 34em) {
  .popupwidth {
    width: 100% !important;
  }
}
.cursor-pointer {
    cursor: pointer;
}
.loaderParent {
  height: 100%;
  width: 100%;
  z-index: 99 !important;
  position: fixed;
  top: 0px;
  left: 0px;
  opacity: 0.98;
  background: #2c3e50;
}
.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999 !important;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  background: #2c3e50;
  opacity: 0.98;
}

@keyframes rotation {
  from {
    opacity: 1;
    transform: rotate(0deg);
  }
  to {
    opacity: 1;
    transform: rotate(359deg);
  }
}
</style>
